import { render, staticRenderFns } from "./ClientProspectStatusList.vue?vue&type=template&id=73b97efb"
import script from "./ClientProspectStatusList.vue?vue&type=script&lang=js"
export * from "./ClientProspectStatusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports